import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FlashMessageWrapper } from './styled';
import { COLORS } from '@app/src/ui';
import { closeUserFlashMessage, openUserFlashMessage } from '@app/src/views/StepTwo/channelPublication';
import { CATEGORIES } from '@app/src/config/categories';

export const FlashMessageDiscount: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const messageData = useSelector(state => state.userMessage.data);
  const isShow = useSelector(state => state.userMessage.isShow);
  const message = messageData && messageData.description;
  const getAliasCategory = () => location.pathname.split('-')[2];
  const categoryConfig = CATEGORIES[getAliasCategory()];

  useEffect(() => {
    if (categoryConfig && location.pathname === categoryConfig.paths.purchasePrint.stepTypePublication) {
      dispatch(openUserFlashMessage());
    } else {
      dispatch(closeUserFlashMessage());
    }
  }, []);

  return (
    <FlashMessageWrapper
      backgroundColor={COLORS.BLUE_LINK}
      textColor="#fff"
      message={message}
      isDisplay={isShow}
    />
  )
};
